import Vue from 'vue'

const AUTH_KILL_USER =(state)=> {
            
    state.authUser=null
};

const AUTH_SET_AUTH = (state) => {
    state.isAuth=false;
            
    if (Vue.dmAuth.isAuthenticated()) {                               
        state.isAuth = true;            
    }
};
const AUTH_SET_USER = (state, payload) => {
                         
    if(Vue.dmAuth.isAuthenticated()) {
        state.authUser = payload;                                           
    }
           
};
const AUTH_SET_REGISTERCOMPANIES = (state, payload) => {
                    
    state.authRegistercompanies = payload;                                               
           
};


export default {
  AUTH_KILL_USER,
  AUTH_SET_AUTH,
  AUTH_SET_USER,
  AUTH_SET_REGISTERCOMPANIES
};